import { useEffect } from 'react'
import { PreviewConfirmModal } from 'components/dialog/ModalTemplate'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { fail, failWithErrorResponse, success } from 'features/toast/Toast'
import {
  hideCampaignTraceUrlEdit,
  setTraceUrlYn,
  showPreview,
  updateCampaignsTraceUrl,
} from 'features/dashboard/operation/campaignTraceUrlEdit/campaignTraceUrlEditSlice'
import { Modal } from 'components/dialog/Modals'
import { refreshDashboard } from 'features/dashboard/dashboardCommonSlice'
import Loading from 'components/loading/Loading'
import RadioButton from 'components/form/RadioButton'
import Table from 'components/table/Table'
import classNames from 'classnames'
import FixedTable from 'components/table/FixedTable'

const CampaignTraceUrlEditModal = () => {
  const dispatch = useDispatch()
  const {
    visible,
    isSubmitting,
    previewVisible,
    isLoading,
    campaigns,
    loadingError,
    form: { traceUrlYn },
    preview: { traceUrlYn: previewTraceUrlYn },
  } = useSelector(
    ({ dashboard }) => dashboard.operation.campaignTraceUrlEdit,
    shallowEqual
  )

  const handlePreview = () => {
    dispatch(showPreview())
  }

  const handleConfirm = async ({ preventClose }) => {
    const { error } = await dispatch(updateCampaignsTraceUrl())
    if (error) {
      preventClose()
      fail('캠페인 추적URL 변경사항을 적용할 수 없습니다.\n다시 시도해 주세요.')
    } else {
      dispatch(refreshDashboard())
      success('캠페인 추적URL 변경사항이 적용되었습니다.')
    }
  }

  useEffect(
    () => () => {
      dispatch(hideCampaignTraceUrlEdit())
    },
    [dispatch]
  )
  useEffect(() => {
    if (loadingError) {
      dispatch(hideCampaignTraceUrlEdit())
      failWithErrorResponse(loadingError, {
        messageMap: {
          409: '삭제된 값이 존재합니다.\n새로고침 후 다시 시도해 주세요.',
        },
      })
    }
  }, [dispatch, loadingError])

  const preview = previewVisible
  const changed = traceUrlYn !== previewTraceUrlYn

  return (
    <Modal on={visible} className="change_layer trace_layer1">
      <PreviewConfirmModal
        title="캠페인 추적URL 변경"
        isSubmitting={isSubmitting}
        onPreview={handlePreview}
        onConfirm={handleConfirm}
        previewDisabled={!changed && preview}
        confirmDisabled={changed && preview}
        handleClose={() => dispatch(hideCampaignTraceUrlEdit())}>
        <p className="desc_info">
          광고 랜딩URL에 파라미터로 광고정보를 전달하는 기능을 설정할 수
          있습니다.
          <br />
          추적URL 제공 파라미터 및 추적URL의 정상 설정 여부는{' '}
          <a
            href="https://cs.kakao.com/helps?articleId=1073200657&service=186&category=721&device=2720&locale=ko"
            target="_blank"
            rel="noopener noreferrer"
            className="fc_empty">
            가이드
          </a>
          를 참고하세요.
        </p>
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <div className="group_inp">
              <RadioButton
                label="설정"
                checked={traceUrlYn === 'Y'}
                onValueChange={() => dispatch(setTraceUrlYn('Y'))}
              />
              <RadioButton
                label="미설정"
                checked={traceUrlYn !== 'Y'}
                onValueChange={() => dispatch(setTraceUrlYn('N'))}
              />
            </div>
            {preview && (
              <FixedTable caption="캠페인 추적URL 변경 이력 표">
                <Table.Head>
                  <Table.Column
                    title="선택 캠페인"
                    className="inner_cell"
                    width={273}
                  />
                  <Table.Column
                    title="변경 전"
                    className="inner_cell"
                    width={132}
                  />
                  <Table.Column title="변경 후" className="inner_cell" />
                </Table.Head>
                <Table.Body>
                  {campaigns.map(
                    ({ id, name, traceUrlYn: beforeTraceUrlYn }) => (
                      <Table.Row
                        rowId={id}
                        key={id}
                        className={classNames({
                          update: beforeTraceUrlYn !== previewTraceUrlYn,
                        })}>
                        <td>
                          <div className="inner_cell">
                            <span className="txt_limit2">{name}</span>
                          </div>
                        </td>
                        <td>
                          <div className="inner_cell">
                            {beforeTraceUrlYn === 'N' ? '미설정' : '설정'}
                          </div>
                        </td>
                        <td>
                          <div className="inner_cell">
                            {previewTraceUrlYn === 'N' ? '미설정' : '설정'}
                          </div>
                        </td>
                      </Table.Row>
                    )
                  )}
                </Table.Body>
              </FixedTable>
            )}
          </>
        )}
      </PreviewConfirmModal>
    </Modal>
  )
}
export default CampaignTraceUrlEditModal
